import * as columnFormatters from "../../../components/column-formatters";

/*

country
name
image
order
createdAt Date
createdAt Time
isActive

*/

const deliveryStatusStyleFormatter = (value) => {
    var style = { textTransform: 'uppercase', fontWeight: '600' }
    if (value === 'PENDING' || value === 'pending')
        style.color = '#FFC609'
    if (value === 'DELIVERED' || value === 'delivered')
        style.color = '#66ff00'
    if (value === 'FAILED' || value === 'failed')
        style.color = '#ff3d3d'

    return style;
}

const dropdownCondition = (value) => {
    if(value?.deliveryStatus === 'FAILED' || value?.deliveryStatus === 'failed')
        return true;

    return false;
}

export const columns = [
    {
        dataField: "noIndex",
        text: "#",
        sort: true,
        show: true,
        format: {
            style: {
                width: '40px',
                minWidth: '40px',
            },
        },
    },
    {
        dataField: "name",
        text: "Name",
        sort: true,
        show: true,
    },
    {
        dataField: "companyId.name",
        text: "Parent Company",
        sort: true,
        show: true,
    },
    {
        dataField: "code",
        text: "Code",
        sort: true,
        show: true,
    },


    {
        dataField: "website",
        text: "Website",
        sort: true,
        show: true,
    },

    
    // {
    //     dataField: "isActive",
    //     text: "isActive",
    //     sort: true,
    //     show: true,
    //     format: {
    //         type: 'isActive'
    //     }
    // },
];
